import { Location as NgLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, filter, map, of, switchMap, tap } from 'rxjs';

import { MwCompanyService } from '@core/auth';

import { MwDialogService, DialogTypes } from 'app/@shared/@components/dialog';
import { UserProfileApiService } from './user-profile-api.service';

@Injectable()
export class UserProfileCheckService {
  constructor(
    private readonly apiService: UserProfileApiService,
    private readonly dialogService: MwDialogService,
    private readonly location: NgLocation,
    private readonly companyService: MwCompanyService,
    private readonly route: Router
  ) {}

  checkDevincoAccountExistence = (): Observable<boolean> =>
    this.location.path().endsWith('user-profile')
      ? of(false)
      : this.companyService
          .getFeatureFlagState('RequireToLinkDevincoConnectAccount')
          .pipe(
            filter((enabled) => enabled == true),
            switchMap(() => this.hasLinkedAccount()),
            filter((hasLinkedAccount) => !hasLinkedAccount),
            switchMap(() => this.apiService.hasDevincoConnectAccount()),
            filter((hasAccount) => hasAccount),
            switchMap(() => this.showAccountLinkDialog()),
            filter((result) => result),
            tap(() => this.route.navigate(['/user-profile']))
          );

  private hasLinkedAccount(): Observable<boolean> {
    return this.apiService
      .getLogins()
      .pipe(
        map((logins) =>
          logins.some((login) => login.loginProvider === 'Devinco')
        )
      );
  }

  private showAccountLinkDialog(): Observable<boolean> {
    return this.dialogService
      .confirm({
        dialogType: DialogTypes.Small,
        translations: {
          title: 'CORE.PAGE.USER_PROFILE.link_your_accounts',
          text: 'CORE.PAGE.USER_PROFILE.link_your_accounts_text',
          yesButton: 'CORE.PAGE.USER_PROFILE.BUTTON.go_to_profile',
          noButton: 'GENERAL.BUTTON.cancel',
        },
      })
      .afterClosed();
  }
}
